module.exports = __webpack_public_path__ + "static/img/hxjs_ct.073f792.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/hxjs_ct.png
// module id = D+fY
// module chunks = 1